import React, { useEffect } from "react";
import "./styled.css";
//redux
import { connect } from "react-redux";
//tags
import MetaTags from "react-meta-tags";

function Office(props) {
  useEffect(() => {
    document.getElementById("title-office").focus();
    props.loadingUserOff();
  }, []);
  return (
    <section className="section-office" id="section-mainStage">
      <MetaTags>
        <title>
          Digital Lovers Festival - Página Conheça Nossos Escritórios
        </title>
      </MetaTags>
      <a id="title-office" className="title-home" tabIndex={12}>
        Página Conheça Nossos Escritórios
      </a>
      <div className="div-cards-office">
        <div className="card-office">
          <a className="title-card-office" id="title-card-office" tabIndex={13}>
            Escritório CENESP
          </a>
          <video
            width={250}
            controls
            tabIndex={14}
          // onPlay={() => pointAction("PALCOPRINCIPALABERTURA")}
          >
            <source src="https://s3.us-east-1.amazonaws.com/bucket.aws.private/hall_83778/ACESSIBILIDADE/ESCRITORIOS/ESCRITORIO%20CENESP%20-%20AUDIODESCRI%C3%87%C3%83O.mp4" />
          </video>
        </div>
        <div className="card-office">
          <a className="title-card-office" id="title-card-office" tabIndex={13}>
            Escritório Florianópolis
          </a>
          <video
            width={250}
            controls
            tabIndex={14}
          // onPlay={() => pointAction("PALCOPRINCIPALABERTURA")}
          >
            <source src="https://s3.us-east-1.amazonaws.com/bucket.aws.private/hall_83778/ACESSIBILIDADE/ESCRITORIOS/ESCRITORIO%20FLORIANOPOLIS%20-%20AUDIODESCRI%C3%87%C3%83O.mp4" />
          </video>
        </div>
        <div className="card-office">
          <a className="title-card-office" id="title-card-office" tabIndex={13}>
            Escritório Jequitiba
          </a>
          <video
            width={250}
            controls
            tabIndex={14}
          // onPlay={() => pointAction("PALCOPRINCIPALABERTURA")}
          >
            <source src="https://s3.us-east-1.amazonaws.com/bucket.aws.private/hall_83778/ACESSIBILIDADE/ESCRITORIOS/ESCRITORIO%20JEQUITIBA%20-%20AUDIODESCRI%C3%87%C3%83O.mp4" />
          </video>
        </div>
        <div className="card-office">
          <a className="title-card-office" id="title-card-office" tabIndex={13}>
            Escritório Recife
          </a>
          <video
            width={250}
            controls
            tabIndex={14}
          // onPlay={() => pointAction("PALCOPRINCIPALABERTURA")}
          >
            <source src="https://s3.us-east-1.amazonaws.com/bucket.aws.private/hall_83778/ACESSIBILIDADE/ESCRITORIOS/ESCRITORIO%20RECIFE%20-%20AUDIODESCRI%C3%87%C3%83O.mp4" />
          </video>
        </div>
        <div className="card-office">
          <a className="title-card-office" id="title-card-office" tabIndex={13}>
            Escritório Rio de Janeiro
          </a>
          <video
            width={250}
            controls
            tabIndex={14}
          // onPlay={() => pointAction("PALCOPRINCIPALABERTURA")}
          >
            <source src="https://s3.us-east-1.amazonaws.com/bucket.aws.private/hall_83778/ACESSIBILIDADE/ESCRITORIOS/ESCRITORIO%20RIO%20DE%20JANEIRO%20-%20AUDIODESCRI%C3%87%C3%83O.mp4" />
          </video>
        </div>
        <div className="card-office">
          <a className="title-card-office" id="title-card-office" tabIndex={13}>
            Escritório Square
          </a>
          <video
            width={250}
            controls
            tabIndex={14}
          // onPlay={() => pointAction("PALCOPRINCIPALABERTURA")}
          >
            <source src="https://s3.us-east-1.amazonaws.com/bucket.aws.private/hall_83778/ACESSIBILIDADE/ESCRITORIOS/ESCRITORIO%20SQUARE%20-%20AUDIODESCRI%C3%87%C3%83O.mp4" />
          </video>
        </div>
        <div className="card-office">
          <a className="title-card-office" id="title-card-office" tabIndex={13}>
            Escritório Uberlândia
          </a>
          <video
            width={250}
            controls
            tabIndex={14}
          // onPlay={() => pointAction("PALCOPRINCIPALABERTURA")}
          >
            <source src="https://s3.us-east-1.amazonaws.com/bucket.aws.private/hall_83778/ACESSIBILIDADE/ESCRITORIOS/ESCRITORIO%20UBERLANDIA%20-%20AUDIODESCRI%C3%87%C3%83O.mp4" />
          </video>
        </div>
      </div>
    </section>
  );
}

const mapStateToProps = function (state) {
  return { state: state };
};

const mapDispatchToProps = function (dispatch) {
  return {
    loadingUserOff: (data) => {
      return dispatch({ type: "LOGIN_NAVIGATION_OFF", data });
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Office);
